//Adapted from: https://reactjs.org/docs/portals.html

import React, { Component } from "react";
import ReactDOM from "react-dom";

const modalRoot = document.getElementById("modal-root");

export default class Modal extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement("div");
  }

  componentDidMount() {
    // The portal element is inserted in the DOM tree after
    // the Modal's children are mounted, meaning that children
    // will be mounted on a detached DOM node. If a child
    // component requires to be attached to the DOM tree
    // immediately when mounted, for example to measure a
    // DOM node, or uses 'autoFocus' in a descendant, add
    // state to Modal and only render the children when Modal
    // is inserted in the DOM tree.
    modalRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    modalRoot.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(
      <div className="modal" onClick={this.props.handleDismiss}>
        <div className="modal-inner" onClick={e => e.stopPropagation()}>
          <i className="icon-cancel modal-close-btn" onClick={this.props.handleDismiss}></i>
          {this.props.children}
        </div>
      </div>,
      this.el
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js